import React from 'react';
import { Grid, Paper, Box, Button } from '@mui/material';
import ChatWindow from '../ChatWindow';
import FlowContainer from '../FlowContainer';
import ClarityAnalytics from '../clarity';

const RequirementsTab = ({
  requirementMessages,
  handleRequirementMessage,
  handleEditMessage,
  handleDeleteMessage,
  isLoading,
  requirementSummary,
  selectedProject,
  requirementNodes,
  setRequirementNodes,
  requirementEdges,
  setRequirementEdges,
  handleNextStepFromRequirements,
  gridContainerStyles,
  leftColumnStyles,
  rightColumnStyles,
  customNodes
}) => {
  return (
    <>
    <><ClarityAnalytics /></>
    <Grid container {...gridContainerStyles}>
      <Grid item {...leftColumnStyles}>
        <Paper elevation={0} className="bg-transparent">
          <ChatWindow
            messages={requirementMessages}
            onSendMessage={handleRequirementMessage}
            placeholder="Enter requirement..."
            title="Requirements Chat"
            onEditMessage={(index) => handleEditMessage("requirement", index)}
            onDeleteMessage={(index) => handleDeleteMessage("requirement", index)}
            isLoading={isLoading}
            summaries={requirementSummary}
            type="requirement"
            selectedProject={selectedProject}
          />
          {requirementMessages.length >= 1 && (
            <Box className="mt-auto p-4">
              <Button
                variant="contained"
                onClick={handleNextStepFromRequirements}
                disabled={isLoading}
                sx={{
                  backgroundColor: "#1a1a1a",
                  "&:hover": {
                    backgroundColor: "#333333",
                  },
                  "&:disabled": {
                    backgroundColor: "#666666",
                  },
                }}
              >
                Next Step: Generate User Stories
              </Button>
            </Box>
          )}
        </Paper>
      </Grid>
      <Grid item {...rightColumnStyles}>
        <Paper
          elevation={1}
          className="h-full rounded-lg overflow-hidden"
          sx={{
            height: {
              xs: "calc(100vh - 300px)",
              md: "calc(100vh - 200px)",
            },
            "& .react-flow__container": {
              height: "100%",
            },
          }}
        >
          <FlowContainer
            type="requirement"
            nodes={requirementNodes[requirementNodes.length - 1]}
            setNodes={setRequirementNodes}
            edges={requirementEdges[requirementEdges.length - 1]}
            setEdges={setRequirementEdges}
            nodeTypes={customNodes}
          />
        </Paper>
      </Grid>
    </Grid>
    </>
  );
};

export default RequirementsTab; 